import { render } from "./AddModeleModal.vue?vue&type=template&id=657284e5&ts=true"
import script from "./AddModeleModal.vue?vue&type=script&lang=ts"
export * from "./AddModeleModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__